import TimezoneDropdown from './TimezoneDropdown';
import withUserId from '../../WithUserId';

const TimezoneDropdownContainer = withUserId(TimezoneDropdown);

export default TimezoneDropdownContainer;
